import { ArrowLeftCircleIcon, XMarkIcon } from "@heroicons/react/20/solid";
import { InboxArrowDownIcon } from "@/icons/outline";
import { format } from "date-fns";
import pDebounce from "p-debounce";
import { useState } from "react";
import "react-datepicker/dist/react-datepicker.css";
import { NotificationManager } from "react-notifications";
import { connect } from "react-redux";
import AsyncSelect from "react-select/async";
import { Actions as ADMINACTIONS } from "../../../store/actions/adminActions";

const PaymentHandlingModal = ({
	closeModal,
	modalStatus,
	client,
	advisors,
	organisations,
	savePaymentHandleStatus,
}) => {
	const [PaymentDropDown, setPaymentDropDown] = useState();

	const organisationResult = pDebounce((inputValue) => {
		if (inputValue?.length <= 2) return;
		return new Promise(async (resolve) => {
			const organisationResult = organisations?.filter(
				(org) =>
					org?.label?.toLowerCase()?.includes(inputValue.toLowerCase()) || org?.value?.includes(inputValue),
			);
			const advisorResult = advisors?.filter(
				(advisor) =>
					advisor?.label?.toLowerCase()?.includes(inputValue.toLowerCase()) ||
					advisor?.value?.includes(inputValue),
			);
			await new Promise((resolve) => {
				setTimeout(() => resolve(), 1000);
			});
			resolve([
				{
					label: "Organisations",
					options: organisationResult,
				},
				{
					label: "Advisors",
					options: advisorResult,
				},
			]);
		});
	}, 300);

	if (!modalStatus) {
		return null;
	}

	return (
		<div
			className="modal"
			tabIndex="-1"
			role="dialog"
			aria-hidden="true"
			style={{ display: "block", background: "rgba(0,0,0,0.4)" }}
		>
			<div className="modal-dialog">
				<div className="modal-content">
					<div
						className="block block-themed block-transparent remove-margin-b"
						style={{ padding: 0 }}
					>
						<div className="block-header bg-primary-dark">
							<ul className="block-options">
								<li>
									<button
										data-dismiss="modal"
										type="button"
										onClick={closeModal}
									>
										<XMarkIcon className="h-6 w-6 mr-3 text-white" />
									</button>
								</li>
							</ul>
							<h3
								className="block-title"
								style={{ padding: "15px 20px" }}
							>
								Confirmation
							</h3>
						</div>
						{/* <div className="modal-body">
              <div className="clearfix"></div>
              <p>Select the company for handling this payment</p>
            </div> */}
						<div
							className="col-sm-12"
							style={{ padding: "4rem", paddingBottom: 0 }}
						>
							<div>
								<div className="col-sm-6 form-material pl-0">
									<label htmlFor="senderName">Sender Name</label>
									<input
										id="senderName"
										className="form-input form-control"
										value={client?.senderName}
										disabled
									/>
								</div>
								<div className="col-sm-6 form-material pl-0">
									<label htmlFor="email">Company / Advisor</label>
									{client?.status == "RequiresReview" ? (
										<div className="form-material form-container">
											<label htmlFor="Company"></label>
											<AsyncSelect
												name="Company"
												loadOptions={organisationResult}
												autoComplete="off"
												onChange={(e) => {
													setPaymentDropDown(e);
												}}
											/>
										</div>
									) : client?.customerReferences?.billingId ==
									  client?.customerReferences?.reference /*add organisation too*/ ? (
										"ORGANISATION" /*NAME OF ORGANISATION HERE*/
									) : (
										""
									)}
								</div>
								<div className="col-sm-6 form-material pl-0">
									<label htmlFor="amount">Amount</label>
									<input
										id="amount"
										className="form-input form-control"
										value={client?.amount / 100}
										disabled
									/>
								</div>
								<div className="col-sm-6 form-material pl-0">
									<label htmlFor="iban">IBAN</label>
									<input
										id="iban"
										className="form-input form-control"
										value={client?.iban}
										disabled
									/>
								</div>
								<div className="col-sm-6 form-material pl-0">
									<label htmlFor="timestamp">Timestamp</label>
									<input
										id="timestamp"
										className="form-input form-control"
										value={format(new Date(client?.timestamp), "do MMM yyyy")}
										disabled
									/>
								</div>
								<div className="col-sm-6 form-material pl-0">
									<label htmlFor="status">Status</label>
									<input
										id="status"
										className="form-input form-control"
										value={client?.status}
										disabled
									/>
								</div>
							</div>
						</div>
						<div
							className="block-content"
							style={{ padding: "0px 20px 1px" }}
						>
							<div
								className="flex-auto buttons"
								style={{ paddingBottom: 20 }}
							>
								{
									<button
										className="btn btn-success pull-right"
										type="submit"
										onClick={() => {
											if (PaymentDropDown) {
												savePaymentHandleStatus({
													id: client?.id,
													org: PaymentDropDown?.org,
													advisor: PaymentDropDown?.advisor,
												});
											} else {
												NotificationManager.error(
													"Please select a company or advisor",
													"Payment Handle",
												);
											}
										}}
									>
										<InboxArrowDownIcon
											className="w-7 h-7 mr-3"
											style={{ verticalAlign: "text-bottom" }}
										/>
										Confirm
									</button>
								}
								{
									<button
										className="btn btn-default pull-left"
										type="submit"
										onClick={() => {
											closeModal();
										}}
									>
										<ArrowLeftCircleIcon
											className="w-7 h-7 mr-3"
											style={{ verticalAlign: "text-bottom" }}
										/>
										No
									</button>
								}
								<div className="clearfix"></div>
							</div>
						</div>
						<div className="clearfix"></div>
					</div>
				</div>
			</div>
		</div>
	);
};

const mapStateToProps = (state, ownProps) => {
	return {
		modalStatus: state.admin.paymentHandleModal,
		org: state.company.settings.org,
		client: state.admin?.paymentHandleModal?.client,
		organisations:
			state?.admin?.organisations?.map((org) => ({ label: org.name, value: org.id, org: org.id })) || [],
		advisors:
			state?.advisors?.advisorList?.map((advisor) => ({
				label: advisor.name,
				value: advisor.id,
				advisor: advisor.id,
			})) || [],
	};
};

const mapDispatchToProps = (dispatch) => ({
	savePaymentHandleStatus: (payload) => dispatch(ADMINACTIONS.savePaymentHandleStatus(payload)),
	closeModal: () => dispatch(ADMINACTIONS.getPaymentHandleModal(false)),
});

export default connect(mapStateToProps, mapDispatchToProps)(PaymentHandlingModal);
